module.exports = __webpack_public_path__ + "img/208H.fe114836.jpg";